import React from "react";
import "../wizard.component.scoped.scss";
import { Box, Button } from "@material-ui/core";
import { useTranslation } from "react-i18next";

export interface WizardFooterProps {
  activeStep: number;
  totalSteps: number;
  onPrev: () => void;
  onNext: () => void;
  onSubmit: () => void;
  isNextDisabled: boolean;
  isSubmitDisabled: boolean;
  submitting?: boolean;
}

const WizardFooter: React.FC<WizardFooterProps> = ({
  activeStep,
  totalSteps,
  onPrev,
  onNext,
  onSubmit,
  isNextDisabled,
  isSubmitDisabled,
  submitting = false,
}) => {
  const { t } = useTranslation();
  const isLast = activeStep === totalSteps - 1;

  return (
    <Box
      display="flex"
      justifyContent="space-between"
      alignItems="center"
      mt={4}
      pt={2}
      style={{ borderTop: "1px solid var(--border, #e0e0e0)" }}
    >
      <Box>
        {activeStep > 0 && (
          <Button
            variant="outlined"
            color="primary"
            onClick={onPrev}
            disabled={submitting}
          >
            {t("PREVIOUS")}
          </Button>
        )}
      </Box>
      <Box>
        {!isLast && (
          <Button
            variant="contained"
            color="primary"
            onClick={onNext}
            disabled={isNextDisabled || submitting}
          >
            {t("NEXT")}
          </Button>
        )}
        {isLast && (
          <Button
            variant="contained"
            color="primary"
            style={{
              width: "8rem",
              height: "2.5rem",
            }}
            onClick={onSubmit}
            size="medium"
            disabled={isSubmitDisabled || submitting}
          >
            {submitting ? <div className="loader"></div> : t("SUBMIT")}
          </Button>
        )}
      </Box>
    </Box>
  );
};

export default WizardFooter;
